const compareModalInitialState = {
  comparisonLabel: '',
  door:            '',
  open:            false,
};

export default compareModalInitialState;